import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { config } from '../../../../config';

interface DirectAuth {
  url: string;
}

@Injectable()
export class DirectAuthService {
  constructor(private http: HttpClient) {}

  get(id: string): Observable<DirectAuth> {
    return this.http
      .get<DirectAuth>(`${config.apiLocation}/utils/directauth/${id}`)
      .map(res => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/utils/directauth.service.ts